import { Stack, Typography, useTheme } from "@mui/material";
import { CheckCircleIcon, CopyInvertedIcon, Input } from "components";
import { useState } from "react";
import toast from "react-hot-toast";

export const CopyWebhookUrlAndSecret = ({
  webhookUrl,
  secretKey,
}: {
  webhookUrl: string;
  secretKey: string;
}) => {
  const theme = useTheme();
  return (
    <Stack
      gap="24px"
      p="16px"
      borderRadius="8px"
      border="1px solid #98C6F1"
      bgcolor="#E8F3FE"
    >
      <Stack gap="8px">
        <Typography variant="subtitle1" color="#0075C8">
          Webhook
        </Typography>
        <Typography variant="body-small" color="lightBg.medium">
          {
            "To start receiving alerts, please configure this Webhook URL and Secret Key under Settings > Webhooks > Create Webhook in your Level RMM account"
          }
        </Typography>
      </Stack>
      <Stack gap="16px">
        <InputField name="webhook_url" label="Webhook URL" value={webhookUrl} />
        <InputField name="secret_key" label="Secret Key" value={secretKey} />
      </Stack>
    </Stack>
  );
};

const InputField = ({
  name,
  label,
  value,
}: {
  name: string;
  label: string;
  value: string;
}) => {
  const theme = useTheme();
  const [isShowValueCopied, setIsShowValueCopied] = useState(false);
  const copyValue = (value: string) => {
    navigator.clipboard.writeText(value);
    setIsShowValueCopied(true);
    setTimeout(() => {
      setIsShowValueCopied(false);
    }, 1000);
  };
  return (
    <Input
      name={name}
      label={label}
      value={value}
      InputProps={{
        endAdornment: isShowValueCopied ? (
          <CheckCircleIcon color="success" fontSize="small" />
        ) : (
          <CopyInvertedIcon
            fontSize="small"
            sx={{
              cursor: "pointer",
              color: theme.palette.lightBg.low,
            }}
            onClick={() => {
              copyValue(value);
            }}
          />
        ),
      }}
      disabled={true}
    />
  );
};
